import { render, staticRenderFns } from "./modalEditarRegistroTemp.vue?vue&type=template&id=6e577c22&"
import script from "./modalEditarRegistroTemp.vue?vue&type=script&lang=js&"
export * from "./modalEditarRegistroTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports